module.exports = __webpack_public_path__ + "static/main_video-7e885a7ee1844f9e4234af40fef30f6f.mp4";